export default {
	employees: 1,
	employers: 2,
	admin: 3
}

export const tableOptions = {
	resizableColumns: false,
	perPage: 10,
	perPageValues: [],
	filterable: false,
	highlightMatches: false,
	filterByColumn: false,
	sortable: [],
	skin: '',
	hiddenColumns: ['userId'],
	headings: {
		delete: false,
		edit: false,
		firstName: 'First Name',
		lastName: 'Last Name',
		dob: 'DOB',
		age: 'Age',
		astrologySign: 'Astrology Sign',
		countryOfBirth: 'Country of Birth',
		signUpDate: 'Sign Up Date',
		lastActivity: 'Last Checked',
		userId: 'Id',
		language: 'Language',
		overwrite: 'Overwrite'
	},
	customSorting: {
		dob: function(ascending) {
			return function(a, b) {
				const parseDob = (val) => {
					if (val === 'Not Entered' || val === null || val === undefined) return null;
					const ts = Date.parse(val);
					return isNaN(ts) ? null : ts;
				};
				const da = parseDob(a);
				const db = parseDob(b);
				if (da === db) return 0;
				if (da === null) return 1; // nulls last
				if (db === null) return -1;
				return ascending ? (da - db) : (db - da);
			};
		},
		signUpDate: function(ascending) {
			return function(a, b) {
				const da = Date.parse(a);
				const db = Date.parse(b);
				const aInvalid = isNaN(da);
				const bInvalid = isNaN(db);
				if (aInvalid && bInvalid) return 0;
				if (aInvalid) return 1; // invalid last
				if (bInvalid) return -1;
				return ascending ? (da - db) : (db - da);
			};
		}
	}
};

export const columns = ['userId', 'email', 'firstName', 'lastName', 'dob', 'age', 'astrologySign', 'countryOfBirth', 'signUpDate', 'lastActivity', 'subscription', 'language', 'overwrite', 'edit' ]
//redo to actual values
